import { Label, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutDataFusionCustomerLookup } from "./autogen/AutogenLayoutDataFusionCustomerLookup";

export class DataFusionCustomerLookup extends AutogenLayoutDataFusionCustomerLookup {

     tableCustomerLookupOnRowDisplay(event: TableRowDisplayEvent) {
        event.getTableRow().forEveryChildComponent(comp => 
            { 
                if(comp instanceof Textbox) {
                    comp.tooltipCallback = null;
                }
            
            }
        );

    }

}

